import * as React from 'react';
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import {t} from "../../core/localization";

export interface DeleteConfirmationProps{
    isOpen: boolean,
    content?: string,
    onDeleteConfirm: () => void,
    onToggleModal: () => void
}

export interface DeleteConfirmationState{
    isOpen: boolean
}

export class DeleteConfirmation extends React.Component<DeleteConfirmationProps, DeleteConfirmationState> {

    constructor(props: DeleteConfirmationProps){
        super(props);

        this.state = {
          isOpen: props.isOpen
        }
    }

    componentWillReceiveProps(nextProps: DeleteConfirmationProps) {
      this.setState({ isOpen: nextProps.isOpen });
    }

    handleCancel(){

      if(this.props.onToggleModal)
        this.props.onToggleModal();

      this.setState({ isOpen: !this.state.isOpen });
    }

    handleOk(){
      if(this.props.onToggleModal)
        this.props.onDeleteConfirm();

      this.setState({ isOpen: !this.state.isOpen });
    }

    render(): React.ReactNode{

        let open = this.state.isOpen;
        let content = this.props.content;

        if(!content)
          content = t.DeleteItemConfirmationMessage

        return(<Dialog
            disableBackdropClick
            disableEscapeKeyDown
            maxWidth="xs"
            aria-labelledby="confirmation-dialog-title"
            open={open}
            >

            <DialogTitle id="confirmation-dialog-title">{t.DeleteConfirmation}</DialogTitle>
            <DialogContent dividers>

            <p>
              {content}
            </p>

            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.handleCancel()} color="primary">{t.Cancel}</Button>
              <Button onClick={() => this.handleOk()} color="primary">{t.Delete}</Button>
            </DialogActions>
          </Dialog>)
    }
}
